import { createContext, useContext, useState } from 'react';

const CypherpunkContext = createContext(null);

export function CypherpunkProvider({ children }) {
  const [cypherpunkMode, setCypherpunkMode] = useState(false);

  const toggle = () => {
    setCypherpunkMode(prev => {
      const next = !prev;
      if (next) {
        document.body.classList.add('cypherpunk-active');
      } else {
        document.body.classList.remove('cypherpunk-active');
      }
      return next;
    });
  };

  return (
    <CypherpunkContext.Provider value={{ cypherpunkMode, toggle }}>
      {children}
    </CypherpunkContext.Provider>
  );
}

export const useCypherpunk = () => useContext(CypherpunkContext);
